import axios from "axios";
import { BASE_URL } from "../const.ts";
import { logout } from "../store/auth.tsx";
import { fetchExamples } from "../store/clickedExample.tsx";

// Function to dynamically get the store to avoid direct import
let store: any = null;

export const setStore = (reduxStore: any) => {
  store = reduxStore;
};

const getHeaders = () => {
  return {
    "Access-Control-Allow-Origin": BASE_URL,
    "Access-Control-Allow-Credentials": true,
    "Content-Type": "application/json",
  };
};

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: getHeaders(),
  withCredentials: true,
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error(
      "Full error object:",
      JSON.stringify(error, Object.getOwnPropertyNames(error)),
    );

    if (error.response) {
      let resolved = false;
      let error_code = null;
      let error_text = null;

      switch (error.response.status) {
        case 401:
          console.log("Unauthorized access");
          store?.dispatch(logout());
          store?.dispatch(fetchExamples({ isLoggedIn: false } as any));
          resolved = true;
          error_code = 401;
          error_text = "Unauthorized";
          break;
        case 422:
          console.log("Validation error");
          break;
        case 500:
          resolved = true;
          error_code = 500;
          error_text = "Internal Server error!!";
          console.log("Server error");
          break;
      }
      if (resolved) {
        // Resolve the promise with a custom response for 401 and 500 errors
        return Promise.resolve({
          data: null,
          status: error_code,
          statusText: error_text,
          headers: error.response.headers,
          config: error.config,
        });
      }
    }
    return Promise.reject(error);
  },
);

// Function to update token dynamically
const updateToken = () => {
  const token = store?.getState().authState.loginToken;
  if (token) {
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axiosInstance.defaults.headers.common["Authorization"];
  }
};

// Subscribe to token changes
export const subscribeToTokenChanges = (reduxStore: any) => {
  reduxStore.subscribe(() => updateToken());
};

export default axiosInstance;
